<template>
  <div>
    <PCNavbar selectIndex="11"/>
    <MobileNavBar :currentActive="10" />
    <ccer/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ccer from '@/components/ccer/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    ccer
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>